import React, { useEffect, useRef, useState } from 'react'
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from 'react-router-dom';
import { Breadcrumb } from '../../../components/dashboard/Breadcrumb';
import Header from '../../../components/global/Header';
import LeftNavbar from '../../../components/global/LeftNavbar';
import SuccessMessage from '../../../components/SuccessMessage';
import Constants from '../../../Constants';
import $ from "jquery";
import APIUrls from '../../../services/APIUrls';
import { getAxiosResponse, putAxiosResponse } from '../../../services/authApiRoutes/APImethods';
import { confirmAlert } from 'react-confirm-alert';
import { transformBlankToNull } from '../../../services/Util';
import { ActivatedClip, BackArrowIcon, DeActivateClip, EditIcon } from '../../../AppIcons';
import { useTranslation } from 'react-i18next';
import AddProjectTemplate from '../../../components/project/projectDetail/AddProjectTemplate';
import { ConditionalBlock } from '../../../ConditionalBlock';

export default function ProjectTemplates() {
    const { t } = useTranslation();
    const translate = t;
    const scrollRef = useRef(null);
    const backRef = useRef();
    const navigate = useNavigate();
    const [projectTemplates, setTemplates] = useState([]);
    const [pending, setPending] = useState(false);
    const [successMessage,setSuccessMessage] = useState("");
    const [template ,setTemplate] = useState({});
    const [refresh,setRefresh] = useState(false);

    useEffect(()=>{
        getAllTemplates();
    },[refresh]);

    useEffect(()=>{
        if (successMessage !== Constants.BLANK) {
            setTimeout(function () {
              setSuccessMessage(Constants.BLANK);
            }, 5000);
          }
    },[successMessage]);

    const columns = [
        {
            id: "name",
            name: "Name",
            maxWidth: "550px",
            selector: (row) => row.name,
            sortable: true,
            cell: (row) => row.name,
        },
        {
            id: "project",
            name: "Created From",
            maxWidth: "550px",
            //selector: (row) => row.project.id,
            sortable: true,
            cell: (row) => (<Link to={`/project/${row.project.id}`}>{row.project.name}</Link>),
        },
        {
            id: "owneruser",
            name: "Owner",
            maxWidth: "550px",
           // selector: (row) => row.ownerUser.userId,
            sortable: true,
            cell: (row) => row.owner.title,
        },
        {
            id: "createdDate",
            name: "Created Date",
            maxWidth: "550px",
            selector: (row) => row.createdDateString,
            sortable: true,
            cell: (row) => row.createdDateString,
        },
        {
            id: "lastupdated",
            name: "Last Updated",
            maxWidth: "550px",
            selector: (row) => row.lastUpdatedString,
            sortable: true,
            cell: (row) => row.lastUpdatedString,
        },
        {
            id: "status",
            name: "Status",
            maxWidth: "550px",
            //selector: (row) => row.enabled,
            sortable: true,
            cell: (row) => row.enabled?"Active":"Inactive",
        },
        {
            name: "Action",
            center: true,
            //selector: (row) => row,
              cell: (row) => (
            <>
                <ActionComponent row={row} />
            </>
         )
        }
    ];

    const disbaleTemplate = (row,flag)=>{
        let title = flag? "Enable Project Template":"Disable Project Template";
        confirmAlert({
            title: title,
            message: <p>Are you sure, you want to proceed ? </p>,
            buttons: [
                {
                    label: "Yes",
                    id: "deleteYes",
                    onClick: () => enableOrDisableTemplate(row,flag),
                    onKeyDown: (e) => {
                    if (e.key === "Tab") {
                        if (e.shiftKey === true) {
                        e.preventDefault();
                        $("#deleteNo").trigger("focus");
                        }
                    }
                    },
                },
                {
                    label: "No",
                    id: "deleteNo",
                    onClick: () => {
                    $('#delete-template').trigger('focus');
                    },
                    onKeyDown: (e) => {
                    if (e.key === "Tab") {
                        if (e.shiftKey === false) {
                        e.preventDefault();
                        $("#deleteYes").trigger("focus");
                        }
                    }
                    if (e.key === Constants.ESCAPE) {
                        $('#delete-template').trigger('focus');
                    }
                    },
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            overlayClassName: "delete_overlay",
        });
    };

    const enableOrDisableTemplate = (row,flag)=>{
        let data = row;
        data.enabled = flag;
        data.name = row.name;
        let message = flag ? "Template is activated successfully.":"Template is deactivated successfully."
        const payload = transformBlankToNull(data);
        updateTemplate(payload,message);
    };

    const updateTemplate = (payload,message)=>{
        putAxiosResponse(APIUrls.PROJECT_TEMPLATE_BY_ID(payload.id),payload)
        .then(()=>{
            setSuccessMessage(message);
            setRefresh(refresh?false:true);
        }).catch((err)=>{
            console.error(err);
        });
    }

    const ActionComponent = (prop) => {
        const template = prop.row;
        return (
          <>
            <div className="flex-center btn-gap10">
                <button className="inline-flex" aria-label="rename" onClick={()=>showAddModal(template)}>
                    {EditIcon}
                </button>
              {template.enabled ? (
                <DeActiveClip template={template} />
              ) : (
                <ActiveClip template={template} />
              )}
            </div>
          </>
        );
    };
    
    const ActiveClip = (prop) => {
        const template = prop.template;
        return (
          <>
            <button className="inline-flex" aria-label="Active" title="Activate"
              onClick={() => disbaleTemplate(template,true)} >
              {ActivatedClip}
            </button>
          </>
        );
    };
    
    const DeActiveClip = (prop) => {
        const template = prop.template;
        return (
          <>
            <button className="inline-flex" aria-label="Deactivate" title="Deactivate" 
            onClick={() => disbaleTemplate(template,false)} >
              {DeActivateClip}
            </button>
          </>
        );
    };

    const getAllTemplates = ()=>{
        getAxiosResponse(APIUrls.PROJECT_TEMPLATE)
        .then((response)=>{
            const data = response.data.data;
            setTemplates(data);
        }).catch((err)=>{
            console.error(err);
        });
    };

    const noDataFoundComponent = () => {
        return (
          <div className="no-data-display align-center">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_DATA_FOUND}</p>
          </div>
        );
    };

    const showAddModal = (template) => {
        setTemplate(template);
        document.body.classList.add("modal-open-9");
    };

    const crumbs = [
        {label:'Settings', url:'settings'},
        {label:'Company departments', url:''},
    ];

  return (
    <>
        <div className="body bg-color">
            <div id="container" className="dashboard-wrapper">
            <Header ref={scrollRef} />
            <LeftNavbar />
            <section className="dashboard-content" ref={scrollRef}>
                <div id="content" className="dashboard-wrap">
                <Breadcrumb crumbs={ crumbs } />
                <div className="system-setting-page">
                    <div className="project-heading userprofile-heading">
                        <div className="back-arrow flex-center">
                            <button ref={backRef} aria-label="Back to Settings" onClick={() => navigate("/settings")}>
                                {BackArrowIcon}
                            </button>
                            <span>Back to Settings</span>
                        </div>
                        <h3>Project Templates</h3>
                        <span>{translate("settings.project_template_description")}</span>
                    </div>
                    <div className="white-bg">
                        <div className="active-purchase-order mar-bot40">
                            <div className="datatable-block">
                                <DataTable 
                                    columns={columns}
                                    data={projectTemplates}
                                    //defaultSortFieldId={1}
                                    //onSort={handleSort}
                                    responsive
                                    striped
                                    pointerOnHover={true}
                                    progressPending={pending}
                                    noDataComponent={noDataFoundComponent()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </section>
            </div>
        </div>
        {successMessage.length >0 ?<SuccessMessage message={successMessage}/> : Constants.BLANK}
        <AddProjectTemplate projectName={template?.name} template={template} isEdit={true} action={updateTemplate}/>
    </>
  )
}
